angular.module('iqxCore')
	.controller('ClientHomeCtrl', function ($scope, ApplicationSvc, ApiSvc, $location, FormSvc, $sce) {
		$scope.checkPermissions('CLIENT')

		$scope.GetTimesheetCount = function () {
			return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateProvTimesheetCount', fetchWithPersonID: true, fetchTarget: 'timesheetCount', multiRow: false })
				.then(function () {
					return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateProvTimesheetForAuthoriseCount', fetchTarget: 'timesheetAuthCount', multiRow: false })
				})
				.then(function () {
					return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateProvTimesheetForApprovalCount', fetchTarget: 'timesheetApprCount', multiRow: false })
				})
		}

		$scope.bulletin = async () => {
			if ($scope.isSwitchedOn("SHOWBULLETIN")){
				await ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetClientBulletin?pDivisionID=' + ApplicationSvc.currentUser.divisionid, fetchTarget: 'bulletin', multiRow: true })
					.then(function () {
						$scope.bulletin.forEach(bulletin => {
							// used to find how much space the HTMLBody element is taking up							
							var contentWidth = document.getElementsByClassName('content')[0].offsetWidth
							if(window.innerWidth > 767){
								contentWidth = contentWidth /2
							}
							contentWidth = contentWidth - 140
							var bulletinTextWidth = ApplicationSvc.measureText(bulletin.HTMLBody)
	
							// show read more button
							if(bulletinTextWidth > contentWidth){
								bulletin.HTMLPreviewFlag = true
							}

							bulletin.HTMLBody = $sce.trustAsHtml(bulletin.HTMLBody)
							bulletin.HTMLTitle = $sce.trustAsHtml(bulletin.HTMLTitle)
						})
					})
				}
		}

		$scope.bulletinInfo = function (item) {
			item.modalBody = /<.+>/g.exec(item.HTMLBody) ? item.HTMLBody : $sce.trustAsHtml(`<pre>${item.HTMLBody}</pre>`)
			return FormSvc.modalInfo($scope, 'bulletinInfo', item)
		}

		$scope.navigateToPage = function (n) {
			$location.url(n)
		}

		$scope.GetCurrentRequirements = function () {
			return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetClientRequirementList', fetchTarget: 'recentReqs', multiRow: true })
		}

		$scope.serialize = function (obj) {
			var str = [];
			for (var p in obj)
				if (obj.hasOwnProperty(p)) {
					str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
				}
			return str.join("&");
		}

		$scope.openReq = function (req) {
			$location.url('/currentrequirements?openReq=1&' + $scope.serialize(req))
		}

		if (ApplicationSvc.currentUser.UserClass == 'CLIENT') {
			$scope.GetTimesheetCount()
			$scope.GetCurrentRequirements()

			ApiSvc.fetch($scope, {
				fetchAPI: 'callresult/NetClientDivision',
				fetchTarget: 'clientDivID',
				multiRow: false,
				booleanFields: ['DepartmentPerm', 'DepartmentTemp']
			})
				.then(function () {
					ApplicationSvc.currentUser.divisionid = $scope.clientDivID.divisionid
				})
				.then($scope.bulletin)
		}
	})
